<template>
	<div>
		<el-dialog
			title="移除确认"
			:visible.sync="dialogVisible"
			width="500px"
		>
			<span>确认移除承运商，后续订单将不再分流给该承运商，不影响正在进行的单</span>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirmBtnFun">确 认</el-button>
        <el-button @click="cancelBtnFun">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
		}
	},
  methods: {
    // 打开弹框
    opendDialog () {
      this.dialogVisible = true
    },
    // 取消弹框
    cancelBtnFun () {
      this.dialogVisible = false
    },
    // 确认
    confirmBtnFun () {
      this.$emit('confirm-remove')
      this.dialogVisible = false
    }
  },
}
</script>
<style scoped lang="scss">
.dialog-footer{
  padding: 16px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/components/RemoveConfirmDialog.vue